import { useState } from 'react';
import { useMachine } from '@xstate/react';
import { CredentialsEntity } from '../../../models/credentials';
import {
  createAwaitingAccountsSelectionMachine,
  MachineProps,
} from './awaitingAccountsSelectionMachine';

export type UseAwaitingAccountsSelectionMachineViewProps = {
  credentials: CredentialsEntity;
} & Pick<MachineProps, 'onDone'>;

export const useAwaitingAccountsSelectionMachineView = ({
  credentials,
  onDone,
}: UseAwaitingAccountsSelectionMachineViewProps) => {
  const [machine] = useState(
    createAwaitingAccountsSelectionMachine({
      initialContext: { credentials, accounts: [] },
      onDone,
    })
  );

  return useMachine(machine);
};
